export default __webpack_public_path__ + "assets/images/c9abd17db84122e4cb3f04eca3cd4c75.jpeg";